import { Route } from '@angular/router';
import { APP_ROUTE_PATHS } from '@ps/core-config';

import { numericParamGuard } from './utils/numeric-param.guard';

/**
 * Matches `APP_ROUTES.BUYER_ROUTES`.
 * Route `path` values are flat (no `/buyer/…` URL prefix); `legacyUnderConstruction`'s
 * second argument is the monolith URL stored on the placeholder page only.
 */
export const BUYER_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.manageSuppliers,
    loadComponent: () =>
      import('../pages/manage-suppliers/manage-suppliers.page').then(
        (m) => m.ManageSuppliersPage,
      ),
    title: 'Manage Suppliers',
  },
  {
    path: APP_ROUTE_PATHS.manageBuyerSettings,
    loadComponent: () =>
      import('../pages/buyers/buyer-settings/buyer-settings.page').then(
        (m) => m.BuyerSettingsPage,
      ),
    title: 'Buyer Settings',
  },
  {
    path: APP_ROUTE_PATHS.tagLibrary,
    loadComponent: () =>
      import('../pages/tags/tag-library/tag-library.page').then(
        (m) => m.TagLibraryPage,
      ),
    title: 'Tags',
  },
  {
    path: APP_ROUTE_PATHS.tagDetail,
    loadComponent: () =>
      import('../pages/tags/tag-detail/tag-detail.page').then(
        (m) => m.TagDetailPage,
      ),
    title: 'Tag Details',
    canActivate: [numericParamGuard('id')],
  },
];
